import { GradingScript } from "@/types";
import { apiClient } from "./api";

export const gradingApi = {
  list: () =>
    apiClient
      .get<{ scripts: GradingScript[] }>("/eval/api/grading-scripts")
      .then((data) => data.scripts || []),
};
